import { gql } from "@apollo/client";

export const GENERAL_COSTS = gql`
  query generalCosts(
    $where: GeneralCostWhereInput
    $gt: GeneralCostWhereInput
    $lt: GeneralCostWhereInput
    $gte: GeneralCostWhereInput
    $lte: GeneralCostWhereInput
    $take: Int
    $skip: Int
    $isIn: JSONObject
    $orderBy: [JSONObject]
  ) {
    generalCosts(
      where: $where
      take: $take
      skip: $skip
      isIn: $isIn
      gt: $gt
      lt: $lt
      gte: $gte
      lte: $lte
      orderBy: $orderBy
    ) {
      data {
        id
        cost
        currency
        recommended
        recommandationScore
        recommendationScore
        costDetails
        commission {
          id
        }
        insurancePlan {
          id
          identifier
          externalId
          icon
          name
          product
          description
          fields
          category
          level
          alias
          risk
          distributions {
            id
            broker {
              id
            }
            commissions {
              id
              value
              type
              withholding
            }
          }
          params {
            rules {
              id
              name
              value
            }
          }
          supportingInformation {
            category
            value
            weight
          }
          insurancePlanCoverages {
            id
            needs {
              id
              level
            }
            coverageCategory {
              id
              value
              label
              icon
              order
            }
            coverageMappings {
              id
              coverage {
                id
                type
                subtype
                additionalInfo
                requirement
                order
              }
              supportingInformation {
                id
                category
                value
                weight
              }
              limits {
                id
                code
                value
              }
            }
          }
        }
        project {
          id
        }
      }
      count
    }
  }
`;

export const GENERAL_COST = gql`
  query generalCost($where: GeneralCostWhereInput) {
    generalCost(where: $where) {
      cost
      currency
      recommended
      costDetails
      commission {
        id
      }
      insurancePlan {
        id
        identifier
        externalId
        name
        description
        icon
        category
        alias
        level
        supportingInformation {
          id
          category
          value
          weight
        }
        insurancePlanCoverages {
          id
          needs {
            id
            level
          }
          coverageCategory {
            id
            value
            label
            icon
            order
          }
          coverageMappings {
            id
            coverage {
              id
              type
              subtype
              additionalInfo
              requirement
              order
            }
            supportingInformation {
              id
              category
              value
              weight
            }
            limits {
              id
              code
              value
            }
          }
        }
      }
      project {
        id
      }
    }
  }
`;

const generalCosts = { GENERAL_COSTS, GENERAL_COST };

export default generalCosts;
